import styled from 'styled-components';
import { Box, Button, Text } from '@rsos/components/capstone/base';

const CONDENSED = 'condensed';
const EXPANDED = 'expanded';

// Common
const DialogContainer = styled(Box).attrs(({ dialogType = CONDENSED }) => ({
  borderRadius: '5px',
  height: 'auto',
  ...(dialogType === EXPANDED && { mb: '5px' }),
}))``;

export const ButtonText = styled(Text).attrs({
  size: 'small',
  paddingRight: '5px',
})``;

export const DialogTitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'bold',
})`
  letter-spacing: normal;
`;

export const DialogContentRemark = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})`
  letter-spacing: normal;
  word-break: anywhere;
`;

// Condensed
export const CondensedDialogContainer = styled(DialogContainer)`
  width: 190px;
  padding-left: 5px;
  padding-top: 3px;
`;

export const DialogButton = styled(Button)`
  margin: 5px 0;
  line-height: 1.2;
  height: 35px;
`;

export const DialogCategoryText = styled(Text).attrs({
  color: '#636363',
  size: 'small',
  fontWeight: 'bold',
})`
  letter-spacing: normal;
  text-transform: uppercase;
`;

export const DialogContentNote = styled(Text).attrs({
  color: '#bababa',
  size: 'xsmall',
})`
  letter-spacing: normal;
  text-align: center;
  padding-top: 5px;
`;

export const DialogContentText = styled(Text).attrs({
  color: '#636363',
  size: 'small',
})`
  letter-spacing: normal;
  text-transform: uppercase;
`;

export const DialogContentWrapper = styled(Box).attrs({
  padding: '14px 0',
})`
  border-bottom: 1px solid #e2e2e2;
`;

export const DialogSourceText = styled(Text).attrs({
  color: '#636363',
  size: 'small',
})`
  letter-spacing: normal;
  text-transform: uppercase;
  padding-bottom: 5px;
  padding-left: 3px;
`;

export const DialogSubContentWrapper = styled(Box).attrs({
  padding: '10px 0 0 0 ',
})``;

// Expanded
export const ExpandedDialogContainer = styled(DialogContainer).attrs({
  bg: 'background',
  p: '15px',
  mb: '5px',
})`
  box-shadow: 2px 2px 18px 1px rgba(0, 0, 0, 0.13);
  font-size: 12px;
  width: 600px;
`;

export const Left = styled(Box).attrs({
  width: '195px',
})``;

export const Right = styled(Box).attrs({
  pl: '15px',
})``;

export const DisclaimerButton = styled(Button)`
  background: ${({ showDisclaimer, theme }) =>
    showDisclaimer ? theme.colors.highlights : 'transparent'};
  ${({ showDisclaimer, theme }) =>
    showDisclaimer && `border: 1px solid ${theme.colors.primaryBaseC2}`};
  border-radius: 5px;
  height: 25px;
  width: 27px;
`;
